import { LogEventTypeEnum } from "../Enums/LogEventTypeEnum";

class LogItem {
    public Id: string;
    public ContactId: string;
    public Action: string;
    public Date: Date;
    public PatientId: string;
    public Pseudonym: string;
    public EncounterId: string;
    public FirstName: string;
    public LastName: string;
    public Username: string;
    public Role: string;
    public IP: string;
    public Description: string;
    public EventType: LogEventTypeEnum;

    constructor() {
        this.Id = "";
        this.ContactId = "";
        this.Action = "";
        this.PatientId = "";
        this.EncounterId = "";
        this.FirstName = "";
        this.LastName = "";
        this.Username = "";
        this.Role = "";
        this.IP = "";
        this.Description = "";
    }
}

export { LogItem };
